<template>
  <van-pull-refresh
    v-model="isLoading"
    :success-text="$18nText(158)"
    :loosing-text="$18nText(159)"
    :pulling-text="$18nText(160)"
    :loading-text="$18nText(161)"
    @refresh="onRefresh"
    class="fatherBox"
  >
    <van-list
      v-model="loading"
      :finished="finished"
      loading-text="..."
      :finished-text="$18nText(162)"
      @load="onLoad"
    >
      <van-button
        class="item"
        @click="itemClick(item)"
        v-for="(item, index) in firstData"
        :key="index"
      >
        <div class="clear top">
          <h3 class="title fl">{{ item.title }}</h3>
          <span v-if="item.isRead" class="status fr">{{ $18nText(76) }}</span>
          <span v-else class="status active fr">{{ $18nText(75) }}</span>
        </div>
        <div class="content">{{ item.content }}</div>
        <div class="clear bottom">
          <p class="time fl">{{ item.created }}</p>
          <!-- <p class="reading fr">9999</p> -->
        </div>
      </van-button>
    </van-list>
  </van-pull-refresh>
</template>
<script>
import { listMsg } from '@/api/message';
import { monitorH5 } from '@/utils/webView';
export default {
  data() {
    return {
      firstData: [],
      count: 0,
      isLoading: false,
      queryFrom: {
        pageNum: 1,
        pageSize: 10
      },
      pages: 0,
      finished: false,
      loading: false
    };
  },
  activated() {
    monitorH5.resetMessage = this.resetMessage;
  },
  methods: {
    resetMessage() {
      // this.firstData = [];
      // this.queryFrom = {
      //   pageNum: 1,
      //   pageSize: 10
      // };
      // this.firstList();
    },
    itemClick(row) {
      row.isRead = true;
      // 给app传参
      // window.webkit.messageHandlers.share.postMessage()
      this.$winOpen({ path: 'messageDetails', query: { id: row.id } });
    },
    firstList(callback) {
      listMsg(this.queryFrom).then(res => {
        this.pages = res.data.pages;
        this.firstData.push(...res.data.list);
        if (this.queryFrom.pageNum < this.pages) {
          this.finished = false;
        } else {
          this.finished = true;
        }
        if (callback) callback();
      });
    },
    onLoad() {
      if (this.queryFrom.pageNum < this.pages) {
        this.queryFrom.pageNum++;
      }
      this.firstList(() => {
        this.loading = false;
      });
    },
    onRefresh() {
      this.queryFrom.pageNum = 1;
      this.firstData = [];
      this.firstList(() => {
        this.isLoading = false;
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.fatherBox {
  min-height: calc(100vh - 0.1rem);
  padding-top: 0.1rem;
  background: #fafafa;
  /deep/.van-pull-refresh__track {
    min-height: calc(100vh - 0.1rem);
  }
  .item {
    height: auto;
    width: 7.1rem;
    margin: 0 0.2rem 0.1rem;
    padding: 0.1rem 0.2rem 0;
    border: none;
    background: #fff;
    border-radius: 0.2rem;
    /deep/ .van-button__text {
      width: 100%;
    }
    .top {
      margin-bottom: 0.1rem;
      .title {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        width: 5.04rem;
        font-size: 0.28rem;
        font-weight: 400;
        line-height: 0.4rem;
        text-align: left;
        color: rgba(43, 47, 56, 1);
      }
      .status {
        width: 0.6rem;
        height: 0.4rem;
        background: #d4d4d4;
        border-radius: 1rem;
        font-size: 0.2rem;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        text-align: center;
        line-height: 0.4rem;
      }
      .active {
        background: rgba(255, 65, 65, 1);
      }
    }

    .content {
      font-size: 0.2rem;
      font-weight: 400;
      line-height: 0.28rem;
      color: rgba(43, 47, 56, 1);
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-align: left;
    }
    .bottom {
      margin-top: 0.18rem;
      border-top: 0.01rem solid #ccc;
      .time {
        font-size: 0.2rem;
        font-weight: 400;
        line-height: 0.6rem;
        color: rgba(43, 47, 56, 1);
      }
      .reading {
        font-size: 0.2rem;
        font-weight: 400;
        line-height: 0.6rem;
        color: rgba(43, 47, 56, 1);
      }
    }
  }
}
</style>
